module.exports = __webpack_public_path__ + "static/media/RiverPlumb.d40ed6fc.webp";